import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  template: `
    @if (toast.current(); as t) {
      <div class="toast" [class]="'toast--' + t.type" role="alert">
        {{ t.message }}
      </div>
    }
  `,
  styles: `
    .toast {
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      padding: 12px 24px;
      font-family: var(--ts-font-display);
      font-size: 13px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: var(--ts-ink);
      z-index: 9999;
      animation: toast-in 0.2s ease-out;
    }

    .toast--success {
      background: var(--ts-chalk);
      border: 1px solid var(--ts-chalk);
    }

    .toast--error {
      background: var(--ts-oxide);
      color: var(--ts-chalk);
      border: 1px solid var(--ts-oxide);
    }

    .toast--info {
      background: var(--ts-ink-3);
      color: var(--ts-chalk);
      border: 1px solid var(--ts-line-2);
    }

    @keyframes toast-in {
      from { opacity: 0; transform: translateX(-50%) translateY(12px); }
      to { opacity: 1; transform: translateX(-50%) translateY(0); }
    }
  `,
})
export class ToastComponent {
  readonly toast = inject(ToastService);
}
